import {BigWinView} from '@gongxigames/framework/slot/modules/bigwin/BigWinViewParticlesV5';
import {BigWinModule} from '@gongxigames/framework/slot/modules/bigwin/BigWinModule';
import {BigWinEvents} from '@gongxigames/framework/slot/modules/bigwin/BigWinEvents';
import {ModuleState} from '@gongxigames/framework/slot';

export class BigWinPlayingState extends ModuleState<BigWinView, BigWinModule> {

    public onEnterState(): void {
        this.module.eventManager.emit(BigWinEvents.STARTED);
        this.module.eventManager.emit('General.UI.DISABLE', BigWinModule.NAME);

        this.view.play(this.module.bigWinType, this.module.isSkippableImmediately,
            this.module.countFrom, this.module.countTo, this.module.isPlayWinMeter);
    }

    public onLeaveState(): void {
        this.module.eventManager.emit(BigWinEvents.FINISHED);
        this.module.eventManager.emit('General.UI.ENABLE', BigWinModule.NAME);
    }

    protected setupEvents(): void {
        this.setEventHandler(BigWinView.VIEW_BIG_WIN_FINISHED, this.onBigWinFinished.bind(this));
        this.setEventHandler('General.UI.SPACEBAR_UP', this.view.skip.bind(this.view));
    }

    protected onBigWinFinished(): void {
        this.module.gotoState(BigWinModule.BASIC_STATE);
    }
}
